import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { langType, withLang } from '../../../i18n';
import {
  navigateTo
} from '../../../util';

const SendReminderIconButton = ({
  route, surveyId, translate: t, disabled
}) => {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      className="actionButton icon--notification"
      title={t('survey.remind')}
      onClick={() => navigateTo(navigate, route, surveyId)}
      disabled={disabled}
      data-cy="send-reminder-icon-button"
    />
  );
};
const {
  string
} = PropTypes;

SendReminderIconButton.propTypes = {
  surveyId: string.isRequired,
  ...langType
};

export default withLang(SendReminderIconButton);
